import { Input, KeyCode } from "../lib/Input";
import { Time } from "../lib/Time";
import Vector2 from "../math/Vector2";
import { SPAbilityOptions } from "../type/AbilityOptions";
import { clamp01 } from "../util";
import SPGameManager from "./SPGameManager";
import SPPlayer from "./SPPlayer";

export default class SPAbility {

    trigger: KeyCode;
    triggerType: (key: KeyCode) => boolean;

    icon: number;
    player: SPPlayer;

    duration: number;
    durationTimer: number = 0;
    cooldown: number;
    cooldownTimer: number = 0;

    get isCurentlyActive() {
        return this.durationTimer > 0;
    }

    constructor(player: SPPlayer, options: SPAbilityOptions) {
        this.player = player;
        this.icon = options.icon;
        this.trigger = options.trigger;
        this.duration = options.duration;
        this.cooldown = options.cooldown;
        this.triggerType = options.triggerType.bind(Input);
    }

    onUse() {}

    onDurationEnd() {}

    onCooldownEnd() {}

    onActiveUpdate() {}

    onUseDuringDuration() {}

    onUpdate() {}

    UseAbility() {
        if (this.isCurentlyActive) {
            this.onUseDuringDuration();
        }

        if (this.cooldownTimer > 0) return;

        this.cooldownTimer = this.cooldown;
        if (this.duration > 0) this.durationTimer = this.duration;
        this.onUse();
    }

    Update() {
        if (this.isCurentlyActive) {
            this.durationTimer -= Time.deltaTime;
            this.onActiveUpdate();

            if (this.durationTimer <= 0) {
                this.durationTimer = 0;
                this.onDurationEnd();
            }
        } else if (this.cooldownTimer > 0) {
            this.cooldownTimer -= Time.deltaTime;

            if (this.cooldownTimer <= 0) {
                this.cooldownTimer = 0;
                this.onCooldownEnd();
            }
        }

        if (this.triggerType(this.trigger)) {
            this.UseAbility();
        }

        this.onUpdate();
    }

    onDraw() {}

    onKeydownDraw() {}

    Draw(index: number) {
        this.onDraw();

        if (Input.GetKey(this.trigger) && this.cooldownTimer === 0) {
            this.onKeydownDraw();
        }

        const ctx = this.player.ctx;
        const engine = this.player.engine;

        const x = this.player.engine.width - 360 + 38*index - 4;
        let keyName: string;

        switch (this.trigger) {

            case KeyCode.Digit1:
                keyName = '1';
                break;
            case KeyCode.Digit2:
                keyName = '2';
                break;
            case KeyCode.Digit3:
                keyName = '3';
                break;
            case KeyCode.Digit4:
                keyName = '4';
                break;
            case KeyCode.Digit5:
                keyName = '5';
                break;
            case KeyCode.Digit6:
                keyName = '6';
                break;
            case KeyCode.Digit7:
                keyName = '7';
                break;
            case KeyCode.Digit8:
                keyName = '8';
                break;
            case KeyCode.Digit9:
                keyName = '9';
                break;
            case KeyCode.Digit0:
                keyName = '0';
                break;
        
            default:
                keyName = this.trigger.toString();
                break;
        }
        
        const position = new Vector2(x, engine.height - 24);
        ctx.fillStyle = this.isCurentlyActive ? '#ffff55' : '#55ff55';
        engine.FillRectScreenFromCenter(position, new Vector2(34, 34));
        SPGameManager.Singleton.DrawAbilityIcon(this.icon, position);

        if (this.isCurentlyActive) {

            ctx.fillStyle = '#ffff55a0';
            ctx.fillRect(position.x - 16, position.y - 16, 32, 32);
            engine.drawTexts([`${Math.ceil(this.durationTimer)}`], position.sub(position.add(Vector2.one.scale(8))), {
                align: 'center',
                baseline: 'middle',
                color: 'black',
                size: 24
            });
            engine.drawTexts([`${Math.ceil(this.durationTimer)}`], position, {
                align: 'center',
                baseline: 'middle',
                color: 'white',
                size: 24
            });
        } else if (this.cooldownTimer > 0) {
            const cdT = clamp01(this.cooldownTimer/this.cooldown);

            ctx.fillStyle = '#5555ffa0';
            ctx.fillRect(position.x - 16, position.y + 15 + (1 - 32*cdT), 32, 32*cdT);

            engine.drawTexts([`${Math.ceil(this.cooldownTimer)}`], position.sub(position.add(Vector2.one.scale(8))), {
                align: 'center',
                baseline: 'middle',
                color: 'black',
                size: 24
            });
            engine.drawTexts([`${Math.ceil(this.cooldownTimer)}`], position, {
                align: 'center',
                baseline: 'middle',
                color: 'white',
                size: 24
            });
        }

        engine.drawTexts([keyName], position.add(new Vector2(15, 16)), {
            align: 'right',
            baseline: 'bottom',
            color: 'white'
        });
    }

}